exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-setting-wrapper{width:130px;height:80px;margin-left:-10px;margin-top:-10px;padding-top:25px;background:#fff;position:absolute;text-align:center}.panel-setting-wrapper i{font-size:20px}th .panel-setting-wrapper{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-95560508","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/metronic/table/header/PanelPropertyActionsHeader.vue
// module id = tm5I
// module chunks = 0 1 2